import React, {useContext, useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import {useHttp} from "../../hooks/http.hook";
import {AuthContext} from "../../context/AuthContext";
import Page from "../Pages/Page";
import BreadCrumbsItems from "../Pages/BreadCrumbsItems/BreadCrumbsItems";
import Calendar from "../Calendar/Calendar";
import {useParams} from "react-router-dom";
import CalendarV2 from "../CalendarV2";
import CalendarModal from "../Calendar/CalendarModal";
import styled from "styled-components";
import useOutsideClick from "../../hooks/useOutsideClick";

let CalendarPageTemplate = (props) => {
    const {request} = useHttp()
    const {token} = useContext(AuthContext)
    const [refresh, setRefresh] = useState(false)
    const [data, setData] = useState()
    const [modal, setModal] = useState(true)

    const modalRef = useRef()

    const toggleModal = (state) => {
        setModal(prev => state || !prev)
    }
    useOutsideClick(modalRef, toggleModal)

    function prepareData(data) {
        return data.map(item => {
            return {
                start: item.dateFrom,
                end: item.dateTo,
                title: item.organization.name,
                orgName: item.organization.name,
                organizationId: item.organizationId,
                medName: item.medCenter.name,
                medId: item.medId,
                color: item.organization.color,
                verificationId: item.verificationId,
                verCenterName: item.verificationCenter ? item.verificationCenter.name : 'sadf',
                comment: item.comments,
                id: item._id,
            }
        })
    }

    const timeoutRefresh = () => {
        setTimeout(() => {
            setRefresh(!refresh)
        }, 10)
    }

    const getCalendar = async () => {
        const url = `${process.env.REACT_APP_BASE_URL}${props.getCalendarAPI.api}`
        const {
            data,
            status
        } = await request(url, props.getCalendarAPI.method, null, {Authorization: `Bearer ${token.token}`})
        if (status === 200) {
            setData(prepareData(data))
        }
    }


    const deleteCalendarItem = async (deletedCalendarItemId) => {
        const url = `${process.env.REACT_APP_BASE_URL}${props.deleteItemAPI(deletedCalendarItemId).api}`
        const {
            data,
            status
        } = await request(url, props.deleteItemAPI().method, null, {Authorization: `Bearer ${token.token}`})
        timeoutRefresh()
        return status === 200 && data.ok === 1;

    }

    const addCalendarItem = async (addedCalendarItem) => {

        const preparedData = {
            address: addedCalendarItem.title ? addedCalendarItem.title : null,
            dateFrom: addedCalendarItem.startDate ? addedCalendarItem.startDate : null,
            dateTo: addedCalendarItem.endDate ? addedCalendarItem.endDate : null,
            medId: addedCalendarItem.medId !== '' ? addedCalendarItem.medId : null,
            organizationId: addedCalendarItem.organizationId ? addedCalendarItem.organizationId : null,
            verificationId: addedCalendarItem.verificationId ? addedCalendarItem.verificationId : null,
            comments: addedCalendarItem.comment ? addedCalendarItem.comment : '',

        }
        const url = `${process.env.REACT_APP_BASE_URL}${props.addItemAPI().api}`
        const {
            data,
            status
        } = request(url, props.addItemAPI().method, preparedData, {Authorization: `Bearer ${token.token}`})

        timeoutRefresh()
        return status === 201 ? data._id : false;
    }

    const editCalendarItem = async (editedCalendarItem) => {
        const preparedData = {
            address: editedCalendarItem.title ? editedCalendarItem.title : '',
            dateFrom: editedCalendarItem.startDate ? editedCalendarItem.startDate : '',
            dateTo: editedCalendarItem.endDate ? editedCalendarItem.endDate : '',
            medId: editedCalendarItem.medId ? editedCalendarItem.medId : null,
            organizationId: editedCalendarItem.organizationId ? editedCalendarItem.organizationId : '',
            verificationId: editedCalendarItem.verificationId ? editedCalendarItem.verificationId : '',
            comments: editedCalendarItem.comment ? editedCalendarItem.comment : '',
        }
        const url = `${process.env.REACT_APP_BASE_URL}${props.updateItemAPI(editedCalendarItem.id).api}`
        const {status} = await request(url, props.updateItemAPI().method, preparedData, {Authorization: `Bearer ${token.token}`})
        timeoutRefresh()
        return status === 200;
    }

    useEffect(() => {
        getCalendar()
    }, [refresh])

    return (
        <>
            <Page mobile={true}>
                <BreadCrumbsItems style={{left: '100px'}} routes={props.breadCrumbsItems}/>
                <div className="calendar">

                    {
                        modal &&
                        <StyledModal  >
                            <div className="modal scale-up-hor-left" ref={modalRef} >
                                <CalendarModal/>
                            </div>
                        </StyledModal>
                    }

                    <CalendarV2 events={data || []}/>
                </div>
            </Page>
        </>
    );
}

const StyledModal = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 11111;
  background: rgba(0, 0, 0, 0.8);
  .modal {
    width: 55%;
    background: white;
  }
`

CalendarPageTemplate = React.memo(CalendarPageTemplate)

export default CalendarPageTemplate;

CalendarPageTemplate.propTypes = {
    getCalendarAPI: PropTypes.any,
    addItemAPI: PropTypes.any,
    deleteItemAPI: PropTypes.any,
    updateItemAPI: PropTypes.any,
    breadCrumbsItems: PropTypes.array,
    amoId: PropTypes.string,
    calendarFormConf: PropTypes.shape({
        verificationCenter: PropTypes.bool
    })
};
// <Calendar currentDate={props.currentDate}
//           setCurrentDate={props.setCurrentDate}
//           showOnCalendar={data}
//           actualOrg={useParams()}
//           className={props.className}
//           calendarFormConf={props.calendarFormConf}
//           addItem={addCalendarItem}
//           onItemDelete={deleteCalendarItem}
//           editItem={editCalendarItem}/>